import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="
            /p1.png" alt="Fashion design and tailoring" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose Pompous Touch & Design?</h2>
            <p>Located in Tansi, Spibat Owerri, Imo State, Pompous Touch & Design has been creating stunning fashion pieces for clients who appreciate quality, style, and attention to detail. We specialize in all kinds of wear with a commitment to excellence.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Premium Quality', desc: 'All our garments are crafted with the finest materials and attention to detail for lasting beauty and comfort.' },
                { icon: 'fas fa-hands-helping', title: 'Personal Service', desc: 'Personalized consultation and fitting services to ensure every piece fits perfectly and meets your expectations.' },
                { icon: 'fas fa-clock', title: 'Timely Delivery', desc: 'Reliable delivery schedules for all projects, ensuring your special occasions are never compromised.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '5+', label: 'Years Experience' },
              { number: '500+', label: 'Happy Clients' },
              { number: '100%', label: 'Satisfaction Rate' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;